import React, { useState } from 'react';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real implementation, this would send the form data to a server
    console.log('Form submitted:', formData);
    alert('Thank you for your inquiry! We will contact you within 24 hours.');
    
    // Reset form
    setFormData({
      name: '',
      email: '',
      phone: '',
      service: '',
      message: ''
    });
  };

  return (
    <div className="ContactPage">
      {/* Hero Section for Contact */}
      <section className="section" style={{ 
        background: 'linear-gradient(135deg, var(--primary-100), var(--background-surface))',
        textAlign: 'center'
      }}>
        <div className="container">
          <h1 style={{ color: 'var(--primary-700)' }}>Contact Us</h1>
          <p style={{ fontSize: 'var(--text-lg)', maxWidth: '800px', margin: '0 auto' }}>
            Ready to transform your outdoor space? Get in touch with our team for a free consultation 
            and let's discuss your landscaping needs.
          </p>
        </div>
      </section>

      {/* Main Contact Section */}
      <section className="section">
        <div className="container">
          <div className="grid grid-cols-2" style={{ gap: 'var(--space-xxxl)' }}>
            <div>
              <h2 style={{ marginBottom: 'var(--space-lg)' }}>Get Your Free Consultation</h2>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name" className="form-label">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder="Your full name"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email" className="form-label">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder="your.email@example.com"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="phone" className="form-label">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="form-input"
                    placeholder="(555) 123-4567"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="service" className="form-label">Service Interest</label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    className="form-input"
                  >
                    <option value="">Select a service</option>
                    <option value="residential-landscaping">Residential Landscaping</option>
                    <option value="commercial-landscaping">Commercial Landscaping</option>
                    <option value="hardscaping">Hardscaping</option>
                    <option value="garden-products">Garden Center Products</option>
                    <option value="design-services">Design Services</option>
                    <option value="maintenance">Lawn Care & Maintenance</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                
                <div className="form-group">
                  <label htmlFor="message" className="form-label">Project Details</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="4"
                    className="form-textarea"
                    placeholder="Tell us about your project, timeline, and any specific requirements..."
                  ></textarea>
                </div>
                
                <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>
                  Schedule Free Consultation
                </button>
              </form>
            </div>
            
            <div>
              <div className="card" style={{ marginBottom: 'var(--space-lg)' }}>
                <h3 style={{ marginBottom: 'var(--space-md)' }}>Visit Our Garden Center</h3>
                <div style={{ marginBottom: 'var(--space-md)' }}>
                  <p style={{ fontWeight: '600', marginBottom: 'var(--space-xs)' }}>Address</p>
                  <p style={{ color: 'var(--neutral-400)' }}>
                    1875 Avon Street Extended<br />
                    Charlottesville, VA 22902
                  </p>
                </div>
                
                <div style={{ marginBottom: 'var(--space-md)' }}>
                  <p style={{ fontWeight: '600', marginBottom: 'var(--space-xs)' }}>Contact</p>
                  <p style={{ color: 'var(--neutral-400)' }}>
                    Phone: <a href="tel:434-295-2159" style={{ color: 'var(--primary-500)' }}>(434) 295-2159</a><br />
                    Email: <a href="mailto:tammy@snowknows.com" style={{ color: 'var(--primary-500)' }}>tammy@snowknows.com</a>
                  </p>
                </div>
                
                <div style={{ marginBottom: 'var(--space-md)' }}>
                  <p style={{ fontWeight: '600', marginBottom: 'var(--space-xs)' }}>Service Areas</p>
                  <p style={{ color: 'var(--neutral-400)' }}>
                    Charlottesville • Albemarle County • Fluvanna County<br />
                    Augusta County • Lake Anna
                  </p>
                </div>
                
                <div>
                  <p style={{ fontWeight: '600', marginBottom: 'var(--space-xs)' }}>Business Hours</p>
                  <p style={{ color: 'var(--neutral-400)' }}>
                    <strong>Summer:</strong> Monday - Saturday, 8 AM - 6 PM<br />
                    <strong>Winter:</strong> Monday - Saturday, 9 AM - 6 PM
                  </p>
                </div>
              </div>
              
              <div className="card" style={{ marginBottom: 'var(--space-lg)' }}>
                <h3 style={{ marginBottom: 'var(--space-md)' }}>Quick Actions</h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-sm)' }}>
                  <a href="tel:434-295-2159" className="btn btn-primary" style={{ textAlign: 'center' }}>
                    Call Now: (434) 295-2159
                  </a>
                  <a href="mailto:tammy@snowknows.com" className="btn btn-secondary" style={{ textAlign: 'center' }}>
                    Send Email
                  </a>
                </div>
              </div>
              
              <div className="card">
                <h3 style={{ marginBottom: 'var(--space-md)' }}>Follow Us</h3>
                <div style={{ display: 'flex', gap: 'var(--space-md)' }}>
                  <a 
                    href="https://www.facebook.com/snowsgardencenter" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn btn-secondary"
                    style={{ flex: 1 }}
                  >
                    Facebook
                  </a>
                  <a 
                    href="https://www.instagram.com/snowsgardencenter/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn btn-secondary"
                    style={{ flex: 1 }}
                  >
                    Instagram
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="section" style={{ backgroundColor: 'var(--background-surface)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 'var(--space-xxxl)' }}>
            <h2>Why Choose Snow's Garden Center?</h2>
            <p style={{ fontSize: 'var(--text-lg)', color: 'var(--neutral-400)', maxWidth: '600px', margin: '0 auto' }}>
              Over 110 years of experience serving Central Virginia's landscaping needs.
            </p>
          </div>
          
          <div className="grid grid-cols-4">
            <div className="card service-card">
              <div className="service-icon">
                <svg fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4M11,16.5L18,9.5L16.59,8.09L11,13.67L7.91,10.59L6.5,12L11,16.5Z"/>
                </svg>
              </div>
              <h3 className="service-title">Fourth Generation</h3>
              <p className="service-description">Family-owned business since 1912</p>
            </div>
            
            <div className="card service-card">
              <div className="service-icon">
                <svg fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12,2L13.09,8.26L19,9L14.18,13L19.09,19L12,16.9L4.91,19L9.82,13L5,9L10.91,8.26L12,2Z"/>
                </svg>
              </div>
              <h3 className="service-title">110+ Years</h3>
              <p className="service-description">Proven track record of excellence</p>
            </div>
            
            <div className="card service-card">
              <div className="service-icon">
                <svg fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22C6.47,22 2,17.5 2,12A10,10 0 0,0 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z"/>
                </svg>
              </div>
              <h3 className="service-title">Local Expertise</h3>
              <p className="service-description">Central Virginia specialists</p>
            </div>
            
            <div className="card service-card">
              <div className="service-icon">
                <svg fill="currentColor" viewBox="0 0 24 24">
                  <path d="M16,13C15.71,13 15.38,13 15.03,13.05C16.19,13.89 17,15 17,16.5V19H23V16.5C23,14.17 18.33,13 16,13M8,13C5.67,13 1,14.17 1,16.5V19H15V16.5C15,14.17 10.33,13 8,13M8,11A3,3 0 0,0 11,8A3,3 0 0,0 8,5A3,3 0 0,0 5,8A3,3 0 0,0 8,11M16,11A3,3 0 0,0 19,8A3,3 0 0,0 16,5A3,3 0 0,0 13,8A3,3 0 0,0 16,11Z"/>
                </svg>
              </div>
              <h3 className="service-title">Full Service</h3>
              <p className="service-description">Complete landscaping solutions</p>
            </div>
          </div>
        </div>
      </section>

      {/* Emergency Contact Section */}
      <section className="section">
        <div className="container">
          <div className="card" style={{ 
            textAlign: 'center',
            background: 'var(--neutral-900)',
            color: 'white'
          }}>
            <h3 style={{ color: 'white', marginBottom: 'var(--space-md)' }}>
              Need Immediate Landscaping Help?
            </h3>
            <p style={{ marginBottom: 'var(--space-lg)', opacity: 0.9 }}>
              For urgent landscaping needs or emergency tree removal, call us directly.
            </p>
            <div style={{ display: 'flex', gap: 'var(--space-md)', justifyContent: 'center', flexWrap: 'wrap' }}>
              <a href="tel:434-295-2159" className="btn" style={{
                backgroundColor: 'var(--primary-500)',
                color: 'white',
                borderColor: 'var(--primary-500)'
              }}>
                Emergency: (434) 295-2159
              </a>
              <a href="mailto:tammy@snowknows.com" className="btn" style={{
                backgroundColor: 'transparent',
                color: 'white',
                border: '1px solid var(--neutral-400)'
              }}>
                Email Us
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;